import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { getSubmittedTranscriptEmailAddress, getSubmittedTranscriptSubject } from 'conversations-message-history/transcript-submission/operators/messageOptionGetters';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import SystemMessage from '../../system-message/SystemMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { EnrollIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const TranscriptSubmissionSystemMessage = ({
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  return /*#__PURE__*/_jsx(SystemMessage, {
    timestamp: getTimestamp(message),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.thread-transcript-submission.description',
      options: {
        email: getSubmittedTranscriptEmailAddress(message),
        subject: getSubmittedTranscriptSubject(message)
      }
    }),
    icon: /*#__PURE__*/_jsx(IconCircle, {
      borderWidth: '0',
      icon: EnrollIcon,
      size: '500'
    }),
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements
  });
};
TranscriptSubmissionSystemMessage.displayName = 'TranscriptSubmissionSystemMessage';
export default TranscriptSubmissionSystemMessage;